/**
 * @file Drop service
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { DropBase } from './drop-base';
import * as moment from 'moment';
var ServiceDrop = /** @class */ (function (_super) {
    tslib_1.__extends(ServiceDrop, _super);
    /**
     * Creates an instance of ServiceDrop.
     */
    function ServiceDrop(domainService, overlayService, dropTargetsService, dialogService, translateService, userService, resourceService) {
        var _this = _super.call(this, 'service-drop', 'APP.EXECUTORS.SERVICE_DROP_NAME', ['Service'], 'Service', domainService, overlayService, dropTargetsService, dialogService, translateService, userService, resourceService) || this;
        // The exactPositioning value for the executors
        _this.exactPositioning = true;
        return _this;
    }
    /**
     * The business logic for this executor and is executed after the
     * validation step and before the finish step.
     *
     * @param {ExecutorData} data The executor data
     * @returns {Promise<any>}
     */
    ServiceDrop.prototype.process = function (data) {
        var _this = this;
        var createEntities = [];
        this.explodeExecutorData(data).forEach(function (slice) {
            createEntities.push(_this.createAttendant(slice.item, slice.target, slice.resource));
        });
        return this.runPromisesParallelAndSave(createEntities);
    };
    /**
     * Create an attendant
     * @private
     * @param {ExecutorData} data The executor data
     * @param {Entity} item The entity
     * @returns {Promise<any>}
     */
    ServiceDrop.prototype.createAttendant = function (item, target, resource) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var itemStart = target.start.toDate();
            // Issue: Ander gedrag drop service vanuit dragsources #4060
            var effort = moment.duration(2, 'hours'); // moment.duration(moment(item['Finish']).diff(moment(item['Start'])));
            var itemFinish = target.start.clone().add(effort).toDate();
            if (item['Purpose'] && item['Purpose'] === 'GENERATED') {
                // Wat doen we met item['Purpose'] === 'FORECAST'?
                // Is dat echt: "Forecast (samengevoegd)"?
                itemStart = item['StartBase'];
                itemFinish = item['FinishBase'];
            }
            var entity = _this.domainService.getEntityType('Attendant').createEntity({
                Name: item['Name'],
                Service_Oid: item['Oid']
            });
            _this.domainService.addEntity(entity);
            _this.domainService.setDefaultValues(_this.userService.user, entity);
            entity['Resource_Oid'] = resource['Oid'];
            entity['Start'] = itemStart;
            entity['Finish'] = itemFinish;
            entity['SumFactor'] = item['SumFactor'];
            resolve(true);
        });
    };
    /**
     * The logic for the showing the valid drop targets
     * @param {ExecutorData} data
     */
    ServiceDrop.prototype.showDropTargets = function (data) {
        var _this = this;
        // Use the DropTargetService to make the drop targets visible
        this.dropTargetsService.doComplyResourcesDropTargets(data, function () {
            return _this.dropTargetsService.doTimeslotDropTargets(data);
        });
    };
    return ServiceDrop;
}(DropBase));
export { ServiceDrop };
